/**
 * Floorplan (načrt prostora) v formi delovnega časa TR.
 *
 * - .tr-floorplan-drop: klik / Enter / povleci-spusti odpre ali sprejme datoteko (nativni input je sr-only)
 * - preverjanje končnice in velikosti pred oddajo (strežnik preveri še enkrat)
 * - .tr-floorplan-current: gumbi Zamenjaj / Odstrani; "Odstrani" preklopi skriti checkbox floorplan_odstrani
 */
export default {
	init() {
		document.querySelectorAll('.tr-floorplan').forEach(setup)
	},
}

function formatSize(bytes) {
	if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB'
	return (bytes / (1024 * 1024)).toFixed(1).replace('.', ',') + ' MB'
}

function setup(root) {
	const input = root.querySelector('input[type="file"]')
	const drop = root.querySelector('.tr-floorplan-drop')
	if (!input || !drop) return

	const idle = drop.querySelector('.tr-floorplan-drop-idle')
	const selected = drop.querySelector('.tr-floorplan-selected')
	const selectedName = selected.querySelector('.tr-floorplan-name')
	const selectedSize = selected.querySelector('.tr-floorplan-size')
	const selectedReplaces = selected.querySelector('.tr-floorplan-replaces')
	const clearBtn = drop.querySelector('.tr-floorplan-clear')
	const error = root.querySelector('.tr-floorplan-error')

	const current = root.querySelector('.tr-floorplan-current')
	const removeCb = current ? current.querySelector('input[type="checkbox"]') : null
	const replaceBtn = current ? current.querySelector('.tr-floorplan-replace') : null
	const removeBtn = current ? current.querySelector('.tr-floorplan-remove') : null
	const removedNote = current ? current.querySelector('.tr-floorplan-removed-note') : null

	const maxBytes = parseInt(root.dataset.maxBytes, 10) || 10 * 1024 * 1024
	const allowedExt = (root.dataset.allowedExt || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean)

	const hasCurrent = () => !!current && !(removeCb && removeCb.checked)

	function showError(msg) {
		error.textContent = msg
		error.classList.toggle('hidden', !msg)
	}

	function validate(file) {
		const ext = (file.name.split('.').pop() || '').toLowerCase()
		if (allowedExt.length && !allowedExt.includes(ext)) {
			return 'Datoteka "' + file.name + '" ni podprta. Dovoljeni so PDF, JPG, PNG, DOC ali DOCX.'
		}
		if (file.size > maxBytes) {
			return 'Datoteka je prevelika (' + formatSize(file.size) + '). Največja dovoljena velikost je ' + formatSize(maxBytes) + '.'
		}
		return ''
	}

	function render() {
		const file = input.files && input.files[0]

		if (file) {
			selectedName.textContent = file.name
			selectedSize.textContent = formatSize(file.size)
			selectedReplaces.classList.toggle('hidden', !hasCurrent())
			idle.classList.add('hidden')
			selected.classList.remove('hidden')
			drop.classList.add('has-file')
			drop.classList.remove('hidden')
		} else {
			selected.classList.add('hidden')
			idle.classList.remove('hidden')
			drop.classList.remove('has-file')
			drop.classList.toggle('hidden', hasCurrent())
		}

		if (current) {
			const removed = removeCb.checked
			current.classList.toggle('is-removed', removed)
			removedNote.classList.toggle('hidden', !removed)
			replaceBtn.classList.toggle('hidden', removed)
			removeBtn.textContent = removed ? removeBtn.dataset.labelUndo : removeBtn.dataset.labelRemove
		}
	}

	function acceptFiles(fileList) {
		const file = fileList && fileList[0]
		if (!file) return
		const msg = validate(file)
		if (msg) {
			input.value = ''
			showError(msg)
			render()
			return
		}
		showError('')
		if (input.files !== fileList) {
			try {
				const dt = new DataTransfer()
				dt.items.add(file)
				input.files = dt.files
			} catch (e) {
				showError('Brskalnik ne podpira odlaganja datotek. Uporabite gumb za izbor datoteke.')
				return
			}
		}
		render()
	}

	input.addEventListener('change', () => acceptFiles(input.files))

	// Klik / tipkovnica na območju (ne pa na label ali gumbih, ki imajo svoje vedenje)
	drop.addEventListener('click', e => {
		if (e.target.closest('label, button, a')) return
		if (drop.classList.contains('has-file')) return
		input.click()
	})
	drop.addEventListener('keydown', e => {
		if ((e.key === 'Enter' || e.key === ' ') && e.target === drop) {
			e.preventDefault()
			input.click()
		}
	})

	// Povleci in spusti
	;['dragenter', 'dragover'].forEach(evt => drop.addEventListener(evt, e => {
		e.preventDefault()
		drop.classList.add('is-dragover')
	}))
	;['dragleave', 'dragend'].forEach(evt => drop.addEventListener(evt, () => drop.classList.remove('is-dragover')))
	drop.addEventListener('drop', e => {
		e.preventDefault()
		drop.classList.remove('is-dragover')
		acceptFiles(e.dataTransfer && e.dataTransfer.files)
	})

	clearBtn.addEventListener('click', e => {
		e.stopPropagation()
		input.value = ''
		showError('')
		render()
	})

	if (replaceBtn) replaceBtn.addEventListener('click', () => input.click())
	if (removeBtn) removeBtn.addEventListener('click', () => {
		removeCb.checked = !removeCb.checked
		render()
	})

	render()
}
